import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, of } from 'rxjs';
import { environment } from '../environments/environment';

export interface course {
  SearchKey?: any
  ItemId?: number
  ItemAlias?: string
  Title: string
  Content?: string
  Summary: string
  PublishDate: string
  VisibilityId?: number
  Notes?: any
  PostAuthorExternalId?: number
  FirstName?: string
  LastName?: string
  EmployeeId?: number
  EmployeeBio?: string
  UserIsAuthenticated?: boolean
  Category?: any
  ResourceURL: string
  ImageName?: string
  NumberOfCEUs?: number
  CertId?: number
  CertName?: any
  CertSubTypeId?: number
  CertSubTypeName?: any
  CategoryId?: number
  CategoryName?: any
  TypeId?: number
  TypeName?: string
  MarketName?: any
  StateId?: any
  StateName?: any
  Id: number
  Comment?: any
  IsMatrixPost: boolean,
  RevisionAuthor?: string,
  Tags?: any,
}


@Injectable({
  providedIn: 'root'
})
export class MyharrellsService {
  courseIdToUse: number = 0; //this is used to pass the course id to the matrix login page

  displayMobileMenu: boolean = false;

  appAPIUrl = environment.appAPIUrl;
  harfilesAPIUrl = environment.harfilesAPIUrl;
  appDomainURL: string = environment.appDomainURL;
  notificationsAPIUrl = environment.notificationsAPIUrl;

  displayOnlineOrderingLink: boolean = true;
  onlineOrderingInEffect: boolean = false;

  loggedInMyHarrellsUser: any; //this is the authenticated user from the login function

  bootstrapViewPortSize: string = ""; //default

  customerSelected: string = "";
  customerNmbrSelected: string = "";
  customerPORequired: boolean = false;
  customerAddressCodeSelected: string = "";
  addressesListMaster: any[] = [];
  addressesListFiltered: any[] = [];
  thisAddressDetails: any = [];
  addressSelected: string = "";
  serviceLocation: any = {};
  invoicesInvoiceNumberSelected: string = "";
  invoicesPOSelected: string = "";
  invoicesItemNumberSelected: string = "";
  invoicesClassSelected: string = "";
  invoicesTypeSelected: string = "";
  invoicesVendorSelected: string = "";
  invoicesFromDate: Date | undefined;
  invoicesToDate: Date | undefined;
  invoiceModeSelected: string = "";
  invoiceShowNonZeroOnlySelected: boolean = false;
  sopNumberSelected: string = "";

  openOrdersModeSelected: string = "Detail"; //default
  openOrdersBillHoldSelected: boolean = false; //default
  orderSOPNumberSelected: string = "";
  ordersItemNumberSelected: string = "";
  ordersClassSelected: string = "";
  ordersTypeSelected: string = "";
  ordersVendorSelected: string = "";

  courseAliasSelected: string = "";
  matrixCourseList: any[] = [];
  publicCourseList: course[] = [];
  matrixCouseToViewAfterSuccessfulLogin: number = 0; //this is used to forward the user to a course selected from the education page that required login to proceed
  selectedCourse: any = {}

  stage: string = "";

  constructor(private http: HttpClient) {
  }

  Login(email: string, password: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/Login/`;
    return this.http.post<any>(url, {
      Email: email,
      Password: password
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductDetailSearchResults', []))
      );
  }

  RegisterNewUser(email: string, password: string, name: string, phone: string, title: string, forceActive: boolean): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/RegisterNewUser/`;
    return this.http.post<any>(url, {
      Email: email,
      Password: password,
      Title: title,
      Name: name,
      Phone: phone,
      ForceActive: forceActive,
      LastRegistrationStatus: "Personal Info Complete"
    })
      .pipe(
        catchError(this.handleError<any[]>('RegisterNewUser', []))
      );
  }

  ShowOnlineOrderingLink(custNmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/ShowOnlineOrderingLink/`;
    return this.http.post<any>(url, {
      CustNmbr: custNmbr,
      EnsurePricingIsFound: true,
      UsersEmail: this.loggedInMyHarrellsUser.Email
    })
      .pipe(
        catchError(this.handleError<any[]>('ShowOnlineOrderingLink', []))
      );
  }

  GetProductPartnerData(custNmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetProductPartnerData/`;
    return this.http.post<any>(url, {
      CustNmbr: custNmbr
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductPartnerData', []))
      );
  }

  GetServiceLocationForPartnerAndAddress(custNmbr: string, addressCode: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetServiceLocationForPartnerAndAddress/`;
    return this.http.post<any>(url, {
      CustNmbr: custNmbr,
      AddressId: addressCode
    })
      .pipe(
        catchError(this.handleError<any[]>('GetServiceLocationForPartnerAndAddress', []))
      );
  }

  GetSelectedAddressDetails() {
    this.thisAddressDetails = this.addressesListFiltered.filter(x => x.Address1.trim() == this.addressSelected.trim())[0];
    sessionStorage.setItem('PartnerSalesPersonId', this.thisAddressDetails.SalesPersonId);
    sessionStorage.setItem('PartnershipCustomerAddressCodeselected', this.thisAddressDetails.AddressId);
    sessionStorage.setItem('PartnershipCustomerAddressSelected', this.thisAddressDetails.Address1 + ', ' + this.thisAddressDetails.City + ', ' + this.thisAddressDetails.State + ' ' + this.thisAddressDetails.ZipCode);
    this.customerAddressCodeSelected = this.thisAddressDetails.AddressId;
  }


  GetCustomerByCustNmbr(custNmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomerByCustNmbr/`;
    return this.http.post<any>(url, {
      CustomerNumber: custNmbr
    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomerByCustNmbr', []))
      );
  }


  GetUsersByCustNmbr(custNmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetUsersByCustNmbr/`;
    return this.http.post<any>(url, {
      CustomerNumber: custNmbr
    })
      .pipe(
        catchError(this.handleError<any[]>('GetUsersByCustNmbr', []))
      );
  }

  GetUserByEmail(eMail: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetUserByEmail/`;
    return this.http.post<any>(url, {
      Email: eMail
    })
      .pipe(
        catchError(this.handleError<any[]>('GetUserByEmail', []))
      );
  }

  PlaceOnlineOrder(harrellsId: string, deliveryDate: string, po: string, notes: string, dispatchNotes): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/PlaceOnlineOrder/`;
    return this.http.post<any>(url, {
      CustomerNumber: sessionStorage.getItem('CustomerNumberSelected'),
      CustomerAddressId: sessionStorage.getItem('PartnershipCustomerAddressCodeselected'),
      DeliveryDate: deliveryDate,
      SalesPersonId: sessionStorage.getItem('PartnerSalesPersonId'),
      Id: sessionStorage.getItem('PartnerSalesPersonId'),
      ShoppingCart: sessionStorage.getItem('ShoppingCart'),
      HarrellsId: harrellsId,
      PO: po,
      Notes: notes,
      DispatchNotes: dispatchNotes,
      UserEmail: this.loggedInMyHarrellsUser.Email,
      RequestedBy: this.loggedInMyHarrellsUser.Email
    })
      .pipe(
        catchError(this.handleError<any[]>('PlaceOnlineOrder', []))
      );
  }


  PlaceEOPFullfillmentRequest(deliveryDate: string, po: string, notes: string, dispatchNotes): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/PlaceEOPFullfillmentRequest/`;
    return this.http.post<any>(url, {
      CustomerNumber: sessionStorage.getItem('CustomerNumberSelected'),
      CustomerAddressId: sessionStorage.getItem('PartnershipCustomerAddressCodeselected'),
      CustomerAddressDesc: sessionStorage.getItem('PartnershipCustomerAddressSelected'),
      DeliveryDate: deliveryDate,
      //SalesPersonId: sessionStorage.getItem('PartnerSalesPersonId'),
      //Id:sessionStorage.getItem('PartnerSalesPersonId'),
      ShoppingCart: sessionStorage.getItem('ShoppingCart').replaceAll('>', '~~~~').replaceAll('<', '!!!!'),
      //HarrellsId: harrellsId,
      PO: po,
      Notes: notes,
      DispatchNotes: dispatchNotes,
      UserEmail: this.loggedInMyHarrellsUser.Email,
      RequestedBy: this.loggedInMyHarrellsUser.Email
    })
      .pipe(
        catchError(this.handleError<any[]>('PlaceEOPFullfillmentRequest', []))
      );
  }





  UpdateOnlineOrderStatusToSubmitted(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/UpdateOnlineOrderStatusToSubmitted/`;
    return this.http.post<any>(url, {
      CustomerNumber: sessionStorage.getItem('CustomerNumberSelected'),
      CustomerAddressId: sessionStorage.getItem('PartnershipCustomerAddressCodeselected'),
      OrderType: (sessionStorage.getItem('EOPMode') == 'true') ? 'bh' : 'olo',
      RequestedBy: this.loggedInMyHarrellsUser.Email
    })
      .pipe(
        catchError(this.handleError<any[]>('UpdateOnlineOrderStatusToSubmitted', []))
      );
  }


  GetRepInfo(salesPersonId: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetRepInfo/`;
    return this.http.post<any>(url, {
      Id: salesPersonId
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepInfo', []))
      );
  }

  GetRepInfoByZipcode(zipCode) {
    const url = `${this.appAPIUrl}/Harrells/GetRepInfoByZipcode/`;
    return this.http.post<any>(url, {
      ZipCode: zipCode
    })
      .pipe(
        catchError(this.handleError<any[]>('GetRepInfoByZipcode', []))
      );
  }

  GetCustomersForZipRep(salesPersonId: number, zipCode) {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersForZipRep/`;
    return this.http.post<any>(url, {
      SalesPersonId: salesPersonId,
      ZipCode: zipCode
    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomersForZipRep', []))
      );
  }

  UpdateUsersRegistrationStatusForCompanyNoMatch(email: string, status: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/UpdateUsersRegistrationStatusForCompanyNoMatch/`;
    return this.http.post<any>(url, {
      Email: email,
      Status: status
    })
      .pipe(
        catchError(this.handleError<any[]>('UpdateUsersRegistrationStatusForCompanyNoMatch', []))
      );
  }

  LogNotificationEntry(companyNameKeyed: string, customerName: string, customerNumber: string, email: string, phone: string, salesPersonId: number, title: string, userName: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/LogNotificationEntry/`;
    return this.http.post<any>(url, {
      CompanyNameKeyed: companyNameKeyed,
      CustomerName: customerName,
      CustomerNumber: customerNumber,
      Email: email,
      Phone: phone,
      SalesPersonId: salesPersonId,
      Title: title,
      UserName: userName,
      ApplicationModuleId: 9
    })
      .pipe(
        catchError(this.handleError<any[]>('LogNotificationEntry', []))
      );
  }

  CreateUserCompanyAssociation(email: string, customerNumber: string, stageCompleted, repId?: number): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/CreateUserCompanyAssociation/`;
    return this.http.post<any>(url, {
      Email: email,
      CustomerNumber: customerNumber,
      LastRegistrationStageCompleted: stageCompleted,
      RepId: repId
    })
      .pipe(
        catchError(this.handleError<any[]>('CreateUserCompanyAssociation', []))
      );
  }



  SendPasswordResetEmail(email: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/SendPasswordResetEmail/`;
    return this.http.post<any>(url, {
      Subject: "Reset Password",
      // Body: "hello", //this id defined in the api for this one
      To: email,
      Domain: this.appDomainURL
    })
      .pipe(
        catchError(this.handleError<any[]>('SendEmail', []))
      );
  }

  PerformPasswordReset(userid: string, code: string, password: string, passwordConfirm: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/PerformPasswordReset/`;
    return this.http.post<any>(url, {
      UserId: userid,
      Code: code,
      Password: password,
      PasswordConfirm: passwordConfirm
    })
      .pipe(
        catchError(this.handleError<any[]>('ValidatePasswordReset', []))
      );
  }


  GetCustomersForThisUser(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersForThisUser/`;
    return this.http.post<any>(url, {
      Email: this.loggedInMyHarrellsUser.Email, //'mwisler@harrells.com',
      IsHarrellsAdmin: (this.loggedInMyHarrellsUser && this.loggedInMyHarrellsUser.RoleName.indexOf('HarrellsAdmin') > -1) ? true : false
    })
      .pipe(
        catchError(this.handleError<any[]>('GetProductDetailSearchResults', []))
      );
  }

  GetCustomersAddresses(custnmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersAddresses/`;
    return this.http.post<any>(url, {
      CustomerNumber: custnmbr,
      Email: this.loggedInMyHarrellsUser.Email,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomersAddresses', []))
      );
  }


  GetThisUserCustomersAddresses(custnmbr: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetThisUserCustomersAddresses/`;
    return this.http.post<any>(url, {
      CustomerNumber: custnmbr,
      Email: this.loggedInMyHarrellsUser.Email,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetThisUserCustomersAddresses', []))
      );
  }


  GetCustomersCredits(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersCredits/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomersCredits', []))
      );
  }



  GetCustomersInvoices(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersInvoices/`;
    return this.http.post<any>(url, {
      Adrscode: (this.customerAddressCodeSelected == "") ? 'a' : this.customerAddressCodeSelected,
      Class: this.invoicesClassSelected,
      CustomerNumber: this.customerNmbrSelected,
      FromDate: this.invoicesFromDate,
      ItemNmbr: this.invoicesItemNumberSelected,
      Mode: this.invoiceModeSelected,
      OffsetNumber: '0',
      RequestType: 'GetCustomersInvoices',
      SOPNumber: this.invoicesInvoiceNumberSelected,
      PO: this.invoicesPOSelected,
      ShowZero: this.invoiceShowNonZeroOnlySelected,
      SortBy: '',
      SortDirection: 'desc',
      ToDate: this.invoicesToDate,
      Type: this.invoicesTypeSelected,
      Vendor: this.invoicesVendorSelected,
      GetAll: true //should be fine even for our biggest vendor 

    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomersInvoices', []))
      );
  }

  GetInvoiceLineItems(invNum: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetInvoiceLineItems/`;
    return this.http.post<any>(url, {
      SOPNumber: invNum
    })
      .pipe(
        catchError(this.handleError<any[]>('GetInvoiceDocument', []))
      );
  }

  GetInvoiceExcel(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetInvoiceExcel/`;
    return this.http.post<any>(url, {
      Adrscode: (this.customerAddressCodeSelected == "") ? 'a' : this.customerAddressCodeSelected,
      Class: this.invoicesClassSelected,
      CustomerNumber: this.customerNmbrSelected,
      FromDate: this.invoicesFromDate,
      ItemNmbr: this.invoicesItemNumberSelected,
      Mode: this.invoiceModeSelected,
      OffsetNumber: '0',
      // RequestType: 'GetCustomersInvoices',
      SOPNumber: this.invoicesInvoiceNumberSelected,
      ShowZero: this.invoiceShowNonZeroOnlySelected,
      SortBy: '',
      SortDirection: 'desc',
      ToDate: this.invoicesToDate,
      Type: this.invoicesTypeSelected,
      Vendor: this.invoicesVendorSelected,
      GetAll: true //should be fine even for our biggest vendor 

    })
      .pipe(
        catchError(this.handleError<any[]>('GetCustomersInvoices', []))
      );
  }





  GetCustomersOpenOrders(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetCustomersOrders/`;
    return this.http.post<any>(url, {
      AdrsCode: (this.customerAddressCodeSelected == "") ? 'a' : this.customerAddressCodeSelected,
      BillHold: this.openOrdersBillHoldSelected,
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.orderSOPNumberSelected,
      Class: this.ordersClassSelected,
      ItemNumber: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      Mode: this.openOrdersModeSelected,
      GetAll: true //should be fine even for our biggest vendor 



    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrGetCustomersOpenOrdersdersOrderDD', []))
      );
  }



  GetOrdersOrderDD(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetOrdersOrderDD/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.sopNumberSelected,
      Class: this.ordersClassSelected,
      ItemNmbr: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      // Mode: this.openOrdersModeSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrdersOrderDD', []))
      );
  }


  GetOrdersItemNmbrDD(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetOrdersItemNmbrDD/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.sopNumberSelected,
      Class: this.ordersClassSelected,
      ItemNmbr: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      // Mode: this.openOrdersModeSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrdersItemNmbrDD', []))
      );
  }

  GetOrdersClassDD(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetOrdersClassDD/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.sopNumberSelected,
      Class: this.ordersClassSelected,
      ItemNmbr: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      // Mode: this.openOrdersModeSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrdersClassDD', []))
      );
  }

  GetOrdersTypeDD(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetOrdersTypeDD/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.sopNumberSelected,
      Class: this.ordersClassSelected,
      ItemNmbr: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      // Mode: this.openOrdersModeSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrdersTypeDD', []))
      );
  }

  GetOrdersVendorDD(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetOrdersVendorDD/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      SOPNumber: this.sopNumberSelected,
      Class: this.ordersClassSelected,
      ItemNmbr: this.ordersItemNumberSelected,
      Type: this.ordersTypeSelected,
      Vendor: this.ordersVendorSelected,
      // Mode: this.openOrdersModeSelected,
    })
      .pipe(
        catchError(this.handleError<any[]>('GetOrdersVendorDD', []))
      );
  }

  GetMyProductsProductDetail(productNumber: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetMyProductsProductDetail/`;
    return this.http.post<any>(url, {
      ItemNmbr: productNumber
    })
      .pipe(
        catchError(this.handleError<any[]>('GetMyProductsProductDetail', []))
      );
  }

  GetPDFDocument(docType: string, docId: string): Observable<any[]> {
    const url = `${this.harfilesAPIUrl}/docs/GetDocument/`;
    return this.http.post<any>(url, {
      DocType: docType,
      Id2: docId

    })
      .pipe(
        catchError(this.handleError<any[]>('GetPDFDocument', []))
      );
  }
  //
  ValidateUserInMatrixLMSSystemAsync(email: string, courseAlias: string, id: number): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/ValidateUserInMatrixLMSSystemAsync/`;
    return this.http.post<any>(url, {
      Email: email,
      ItemAlias: courseAlias,
      Id: id
    })
      .pipe(
        catchError(this.handleError<any[]>('ValidateUserInMatrixLMSSystemAsync', []))
      );
  }

  GetMatrixLMSCourses(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetMatrixLMSCourses/`;
    return this.http.get<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetMatrixLMSCourses', []))
      );
  }

  GetEducationPostsNonMatrix(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetEducationPostsNonMatrix/`;
    return this.http.post<any>(url, {
    })
      .pipe(
        catchError(this.handleError<any[]>('GetEducationPostsNonMatrix', []))
      );
  }

  GetEducationPostNonMatrixCourseDetail(courseAlias: string): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/GetEducationPostsNonMatrix/`;
    return this.http.post<any>(url, {
      ItemAlias: courseAlias
    })
      .pipe(
        catchError(this.handleError<any[]>('GetEducationPostsNonMatrixCourseDetail', []))
      );
  }

  
  EBizAutoSignIn(): Observable<any[]> {
    const url = `${this.appAPIUrl}/Harrells/EBizAutoSignIn/`;
    return this.http.post<any>(url, {
      CustomerNumber: this.customerNmbrSelected,
      Email: this.loggedInMyHarrellsUser.Email,
    })
      .pipe(
        catchError(this.handleError<any[]>('EBizAutoSignIn', []))
      );
  }  

  getViewport() {
    if (typeof document !== 'undefined') {
      // const width = Math.max(document.documentElement.clientWidth,window.innerWidth || 0)
      const width = Math.max(document.documentElement.clientWidth || 0)
      if (width <= 576) return 'xs'
      else if (width <= 768) return 'sm'
      else if (width <= 992) return 'md'
      else if (width <= 1200) return 'lg'
      else if (width <= 1400) return 'xl'
      else return 'xxl'
    }
    else {
      //should never happen - doing the check for devs who freak out over the read message in the console 
      return ''
    }
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // // TODO: send the error to remote logging infrastructure
      // console.error(error); // log to console instead

      // // TODO: better job of transforming error for user consumption
      // console.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }


}
